'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var FlagIcon = function FlagIcon(_ref) {var countryCode = _ref.countryCode;return (
    _react2.default.createElement('span', { className: (0, _classnames2.default)('flag-icon', 'flag-icon-' + countryCode) }));};


FlagIcon.propTypes = {
  countryCode: _propTypes2.default.string };exports.default =


FlagIcon;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FlagIcon/FlagIcon.js
// module id = 2661
// module chunks = 0